import { useQuery } from '@tanstack/react-query'
import api from '../../api'
import type { MultiTenantRequest } from '../../types/multiTenantRequest'

const useSingleMultiTenantRequest = (multiTenantRequestID: string) => {
	return useQuery({
		queryKey: ['multiTenantRequest', multiTenantRequestID],
		queryFn: () =>
			api.multiTenantRequests.getSingleMultiTenantRequest(multiTenantRequestID),
		enabled: !!multiTenantRequestID,
		retry: false,
		select(data) {
			const body = data?.body
			if (Array.isArray(body) && body.length > 0)
				return body[0] as MultiTenantRequest
			if (body && typeof body === 'object' && !Array.isArray(body))
				return body as MultiTenantRequest
			return null
		}
	})
}

export default useSingleMultiTenantRequest
